(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["groots-referral-banner"] && !Shopify.designMode) return;
  try {
    const notice = document.querySelector('[data-groots-referral-notice]');
  const referral = new URL(location.href).searchParams.get('groots_referral') || '';
  if (notice && /^GROOT-[ACDEFGHJKLMNPQRTUVWXY34679]{4}$/.test(referral)) {
    notice.hidden = false;
    notice.querySelector('button').addEventListener('click', () => { notice.hidden = true; });
  }
  } catch(e) { console.error(e); }
})();

})();
